// extracted by mini-css-extract-plugin
export default {"productImageContainer":"ProductImage_productImageContainer__ydRtL","printImage":"ProductImage_printImage__iO1IV"};